"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNodesTree = void 0;
const react_1 = require("react");
const ramda_1 = require("ramda");
const constants_1 = require("../../constants");
const nodes_tree_context_1 = require("../contexts/nodes-tree.context");
const utils_1 = require("../../utils");
const useNodesTree = () => {
    const { setNodesTree } = (0, react_1.useContext)(nodes_tree_context_1.NodesTreeContext);
    const getTaxonomyNodeTitle = (classes, node) => { var _a, _b; return (_b = (_a = classes[node.classId]) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : ''; };
    const getV2Ids = (taxonomyNodes, classes) => {
        const descendantsOfV2 = (0, ramda_1.flatten)(taxonomyNodes)
            .filter((node) => node.classId !== constants_1.TAXONOMY_CLASS_V2_ID)
            .map((node) => (node.parentId === constants_1.TAXONOMY_CLASS_V2_ID ? Object.assign(Object.assign({}, node), { parentId: null }) : node));
        const descendantsOfV2Tree = (0, utils_1.getTreeData)(descendantsOfV2, (nodeId) => getTaxonomyNodeTitle(classes, nodeId));
        const v2TerminalIds = (0, utils_1.getTerminalNodes)(descendantsOfV2Tree);
        const v2Ids = descendantsOfV2.map(({ id }) => id);
        setNodesTree(descendantsOfV2Tree);
        return [v2Ids, v2TerminalIds];
    };
    return { getV2Ids };
};
exports.useNodesTree = useNodesTree;
exports.default = exports.useNodesTree;
